export default {
    dynamicFormsViewAnswers_title: "Respuestas",
    dynamicFormsViewAnswers_updatedAt: "Actualizado el",
    dynamicFormsViewAnswers_updatedBy: "Actualizado por",
    dynamicFormsViewAnswers_advancedFilters: "Páginas",
}